import React, { useState, useContext } from "react";
import Avatar from "@mui/material/Avatar";
import { styled } from '@mui/system';
import { firebaseHelper } from 'ui';


const MyAvatar = styled(Avatar)({
    color: "#ffffff",
    backgroundColor: "gray",
    height: "30px",
    width: "30px",
  });
export const MyProfilePic = ({img, defaultText='M'}) => {
   if (img) return <MyAvatar src={firebaseHelper.URLFromRef(img, true)} />;
   else return <MyAvatar>{defaultText}</MyAvatar>;
}